export function getMemberGalleyUrl (memberId: number, galleyType: string): string {
  const baseUrl = String(window.env.REACT_APP_API_URL)
  return `${baseUrl}/api/v1/us/member/${memberId}/galley/?type=${galleyType}`
}
